import './style.css'
import Experience from './experience/experience';

const canvas = document.querySelector('canvas.webgl')
new Experience(canvas);